<template>
    <div>
        <section class="player-list">
            <v-container>
                <v-row>
                    <v-col cols="14" offset="1" md="12" offset-md="2">
                        <h2 class="section-subtitle">Přehled hráčů</h2>
                        <v-row>
                            <v-col cols="14" offset="1" sm="10" offset-sm="3">
                                <v-form>
                                    <v-text-field
                                        v-model="searchPhrase"
                                        dark
                                        return-object
                                        clearable
                                        hide-details
                                        append-icon="mdi-magnify"
                                        label="HLEDAT HRÁČE"
                                    >
                                    </v-text-field>
                                </v-form>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </section>
        <section class="player-list player-list--grey">
            <v-container>
                <v-row>
                    <v-col cols="14" offset="1" md="12" offset-md="2">
                        <v-data-table
                            :headers="header"
                            :items="users"
                            :search="searchPhrase"
                            :loading="loading"
                            must-sort
                            sort-by="nickname"
                            :items-per-page="100"
                            :footer-props="{ itemsPerPageOptions: [100], disableItemsPerPage: true }"
                            class="transparent player-list__table"
                        >
                            <template v-slot:item="props">
                                <tr>
                                    <td>
                                        <div class="">
                                            <span>
                                                <user-avatar-view :settings="props.item.avatar" />
                                                {{ props.item.nickname }}
                                            </span>
                                        </div>
                                    </td>
                                    <td>
                                        <router-link class="order__flex" v-if="props.item.teamId !== null"
                                                     :to="{ name: 'teamDetail', params: { id: props.item.teamId } }">
                                            <team-blazon-view :settings="props.item.teamBlazon" class="small" />
                                            <span>{{ props.item.teamName }}</span>
                                        </router-link>
                                    </td>
                                    <td><div class=""><span>{{ props.item.cityName }}</span></div></td>
                                    <td>
                                        <div class="team-members__flex">
                                            <v-btn dark large class="btn-without-border" icon
                                                   :to="{ name: 'userDetail', params: { id: props.item.id } }">
                                                Detail
                                            </v-btn>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>

            </v-container>
        </section>
    </div>
</template>

<script>
    import { LISTING_USERS_REQUEST } from '../store/actions/user'
    import TeamBlazonView from '../components/TeamBlazon/TeamBlazonView';
    import UserAvatarView from '../components/UserAvatar/UserAvatarView';

    export default {
        components: { UserAvatarView, TeamBlazonView },
        data () {
            return {
                header: [
                    {
                        text: 'Hráč',
                        value: 'nickname',
                    },
                    {
                        text: 'Tým',
                        value: 'teamName',
                    },
                    {
                        text: 'Město',
                        value: 'cityName',
                    },
                    {
                        text: 'Akce',
                        value: 'id',
                        sortable: false,
                        align: 'center',
                        width: 60,
                    },
                ],
                searchPhrase: '',
                users: [],
                loading: false,
            };
        },
        async created () {
            try {
                this.loading = true;
                this.users = await this.$store.dispatch('user/' + LISTING_USERS_REQUEST);
            } catch (e) {
                this.$toast.error('Při načítání seznamu hráčů došlo k chybě.');
            } finally {
                this.loading = false;
            }
        },
    }
</script>
